export const documentLogin = {
  DOCUMENT_PLACEHOLDER: 'XXX.XXX.XXX-XX',
  Continue: 'Continuar',
  Document: 'CPF',
  Identification: 'Identificação',
  'Invalid document': 'CPF inválido',
  'Please, confirm your document to continue':
    'Por favor, confirme seu CPF para continuar',
  'Please, inform a valid document': 'Por favor, informe um CPF válido',
  'Unable to find your account': 'Não foi possível encontrar sua conta',
  'Validated successfully!': 'Validado com sucesso!',
};
